import React from "react";

export const CardText = ({ title, text1, text2, fade }) => {
    return (
        <div className="col-sm mb-3 mb-sm-0" data-aos={fade}>
            <div className="card welcome-card">
                <div className="card-body">
                    <h3 className="card-title">{title}</h3>
                    <p className="card-text mb-4">{text1}</p>
                    <p className="card-text">{text2}</p>
                </div>
            </div>
        </div>
    );
};